<template>
	<div v-if="isCodeArive === false" class="auth-form">
		<div class="text-center logo"><img :src="stylePathToLogo || '/static/img/logo/logo.png'" /></div>

		<h4 class="text-center">{{ formData && formData.title ? formData.title : 'forget/title' | ftc }}</h4>

		<template v-if="errorWithLogout">
			<div class="text-center alert alert-danger" style="margin: 30px 0">
				<p style="margin: 0; padding: 10px;" v-withSafeTags="errorWithLogout"></p>
			</div>
			<button type="button" class="btn btn-submit btn-primary btn-block" @click.prevent="logOut">{{ 'login/logout' | ftc }}</button>
		</template>

		<template v-if="!errorWithLogout">

			<div v-if="form_ErrorMessage">
				<div class="alert alert-danger w5-error-block"
					role="alert"
					style="padding: 10px; margin: 20px 0 20px"
					v-withSafeTags="localeFtc(form_ErrorMessage)">
				</div>
	
				<button type="button" class="btn btn-submit btn-primary btn-block" @click.prevent="softReloadApp">{{ 'main/update' | ftc }}</button>
			</div>

			<form v-if="formData && !successMessage" class="w5-from" autocomplete="off">
				<fieldset :disabled="form_Loading">

					<div v-for="(row, index) in formData.fields" :key="index" class="w5-form-row">
						<template v-if="row && row.length">
							<template v-for="field in row">
								<Field v-if="['locale', 'code'].indexOf(field._field_name) < 0"
									:key="field._field_name"
									:ref="field._field_name"
									:isVisibleRow="field._visible"
									:Field="field"
									v-model="field.value"
									style="padding: 10px 0"
									@valueChanged="onFormFieldChanged(field, formData)"
									@blur="onFormBlur(field, formData)"
									@focus="onFormFocus(field, formData)"
									@enterKeyDown="onFormEnterKeyDown"
								/>
							</template>
						</template>
					</div>

					<div class="w5-field text-center" style="padding: 10px 0">
						<img v-if="form_Loading" src="/static/img/loading32.gif" />
						<button v-else
							class="btn btn-submit btn-primary btn-block"
							type="button"
							ref="button"
							@click="request">{{ 'login/remind' | ftc }}</button>
					</div>

				</fieldset>
			</form>
			<div v-else :style="form_ErrorMessage || successMessage ? 'height: 0' : 'height: 135px'"></div>

			<div v-if="successMessage" class="text-center alert alert-success" style="margin: 30px 0">
				<p style="margin: 0; padding: 10px;" v-withSafeTags="successMessage"></p>
			</div>

			<div v-if="formData && !form_Loading && !form_ErrorMessage" style="margin:10px 0">
				<template v-if="!successMessage">
					<span>{{ 'login/remembered' | ftc }}</span>
					<router-link to="/login">{{ 'main/enter' | ftc }}</router-link>
				</template>
			</div>

		</template>
	</div>

	<div v-else class="user-forget-form">
		<h2>{{ 'forget/title' | ftc }}</h2>
		<!-- блок с ошибкой -->
		<div v-show="isCodeError !== ''" class="alert alert-danger code-error" role="alert"><p v-withSafeTags="localeFtc(isCodeError)"></p></div>
		<!-- блок с успехом -->
		<div v-show="successMessage !== '' && successMessage !== false" class="alert alert-success code-success" role="alert">{{ successMessage | ftc }}</div>
		<!-- ссылка на главную -->
		<br>
		<div class="text-left code-link">{{ 'login/return_to_main_page1' | ftc }} <a href="/" :title="'login/return_to_main_page2' | ftc">{{ 'login/return_to_main_page2' | ftc }}</a></div>
	</div>
</template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Field from '@/components/elements/formfield'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'rememberForm',

	//=========================================================================
	// свойства компонента
	//=========================================================================
	data() {
		return {
			// сообщение об успехе
			successMessage: '',
			// ошибка с разлогином
			errorWithLogout: '',
			// данные формы
			formData: null,

			// если получен код
			isCodeArive: false,
			isCodeError: '',
			isCode: null
		}
	},
	//=========================================================================
	// создание компонента
	//=========================================================================
	created() {
		// если это пришли по ссылке напоминания пароля
		if (this.$route.path === '/user/forget')
		{
			// ставим признак тогда что это страница обработки кода
			this.isCodeArive = true

			// должен быть задан код - первое свойство объекта query
			let _keys = Object.keys(this.$route.query)
			// если кода нет - выводим ошибку и все
			if (!_keys.length)
			{
				this.isCodeError = 'forget/notcode'
				return
			}

			// получаем код
			let _code = _keys[0]
			// проверка корректности кода
			if (_code === undefined || _code === null || String(_code).trim() === '')
			{
				this.isCodeError = 'forget/notcode'
				return
			}

			// запоминаем код
			this.isCode = _code
		}

		// если это обработка кода - то это все
		if (this.isCodeArive) return

		// запросим форму
		this.formRequest()
	},
	//=========================================================================
	// компонент примонтирован в DOM
	//=========================================================================
	mounted() {
		// если задан код для напоминания пароля
		if (this.isCodeArive && this.isCode)
		{
			// готовим url запроса
			let _url = '/user/forget?' + this.isCode

			// запрос
			this.forms_GetThenPost(_url, null,
				// успех
				data => {
					if (data && typeof data === 'object' && 'status' in data && data['status'] === 'ok' && data.content)
					{
						// покажем сообщени
						this.successMessage = data.content
						// на этом все
						return
					}

					// ошибка
					this.isCodeError = this.localeFtc('<b>main/error_desc</b><br>')
					if (data && typeof data === 'object' && data.content) this.isCodeError += data.content
					else this.isCodeError = this.isCodeError.replace(':', '.').replace(/strong/g, 'span')
				},
				// неудача
				error => {
					this.isCodeError = this.localeFtc('<b>main/error_desc</b><br>')
					let _cnt = 0
					if (error.status === 'error')
					{
						for (let k in error) if (error.hasOwnProperty(k))
						{
							this.isCodeError += error[k] + ' <br> '
							_cnt++
						}
					}

					if (_cnt === 0)
						this.isCodeError = this.isCodeError.replace(':', '.').replace(/strong/g, 'span')
					else if (_cnt > 1)
						this.isCodeError = this.isCodeError.replace('Возникла ошибка', 'Возникли ошибки')
				}
			)
		}
	},
	//=========================================================================
	// функции компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// запрос данных формы
		//---------------------------------------------------------------------
		formRequest() {
			// запросим форму
			this.getFormFromCache('/user/forget')
			.then(formData => {
				if (formData &&
					formData.title &&
					formData.fields &&
					formData._csrf &&
					formData.model)
				{
					const newData = this.parseFormData(formData, this.formData)
					if (newData) this.formData = newData
				}

				if (formData &&
					formData.status === 'error' &&
					formData.message &&
					formData.message.length)
				{
					this.form_ErrorMessage = this.localeFtc(formData.message)

					// если это Blacklisted
					if (String(formData.message).toLowerCase().indexOf('blacklisted') !== -1)
					{
						// сборс данных формы
						this.formData = null
					}
				}
			})
		},

		//---------------------------------------------------------------------
		// реакция на отрицательный результат запроса
		//---------------------------------------------------------------------
		failRequest(error) {
			this.form_ErrorMessage = false
			this.errorWithLogout = ''

			if (error && typeof error === 'object' &&
				error.data &&
				error.data.status === 'error' && error.data.content && error.data.title &&
				error.data.content === 'user/need_logout')
			{
				this.errorWithLogout = '<b>' + this.localeFtc(error.data.title) + '</b><br><br>' + this.localeFtc(error.data.content)
				return
			}

			let _msg = this.localeFtc('main/validation_error')
			let _isError = false

			if (error && typeof error === 'object' && error['email'])
			{
				_isError = true

				if (Array.isArray(error['email']) && error['email'].length) _msg = this.localeFtc(error['email'][0])
				else _msg = this.localeFtc(error['email'])

				const field = this.findFormField('email', this.formData['fields'])
				if (field) field['_errMsg'] = _msg
			}

			if (error && typeof error === 'object' && error['captcha'])
			{
				_isError = true

				if (Array.isArray(error['captcha']) && error['captcha'].length) _msg = this.localeFtc(error['captcha'][0])
				else _msg = this.localeFtc(error['email'])

				const field = this.findFormField('captcha', this.formData['fields'])
				if (field) field['_errMsg'] = _msg
			}

			// если это не ошибка по полю
			if (!_isError)
			{
				// общая ошибка
				this.form_ErrorMessage = _msg
			}

			// в любом случае запросим форму - так как может появиться поле "капча"
			this.formRequest()
		},

		//---------------------------------------------------------------------
		// запрос
		//---------------------------------------------------------------------
		request() {
			// проверка загрузки
			if (this.form_Loading) return

			// проверка формы
			if (!this.formData || !this.formData['fields']) return

			// обнуляем ошибку и сообщение
			this.form_ErrorMessage = false
			this.successMessage = ''

			// бежим по всем полям и собираем данные
			const _data = this.collectFormData(this.formData['fields'], this.localFormValidation)
			// если данные по каким либо причинам собрать не удалось
			if (_data === false) return

			// запрос на восстановление пароля
			let _url = '/user/forget'
			this.forms_GetThenPost(_url, _data,
				// успех
				() => {
					// покажем сообщени
					this.successMessage = this.localeFtc('forget/success<br><br> forget/email_sent')
				},
				// неудача
				(error) => {
					// если это 403 Blacklisted
					if (error && error.status === 403 && error.data && error.data.content === 'Blacklisted')
					{
						// ставим текст сообщения
						this.form_ErrorMessage = this.localeFtc('login/blacklisted')
						// обнуляем форму
						this.formData = null
					}
					// иная ошибка
					else this.failRequest(error)
				}
			)
		},

		//---------------------------------------------------------------------
		// процедура выхода
		//---------------------------------------------------------------------
		logOut() {
			// запрос на выход из системы
			this.forms_GetThenPost('/logout', false,
				// успех
				() => {
					this.$store.commit('dropAuth')
					this.$router.push('/login')
				},
				// провал
				() => {
					this.$router.push('/')
				}
			)
		}

		//---------------------------------------------------------------------
	},

	//=========================================================================
	components: {
		Field
	}

	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.user-forget-form {
	text-align: center;
}

.user-forget-form > .code-error,
.user-forget-form > .code-success,
.user-forget-form > .code-link {
	margin: auto;
	width: 50%;
}

@media (max-width: 767px) {
	.user-forget-form > .code-error,
	.user-forget-form > .code-success,
	.user-forget-form > .code-link {
		width: 300px;
	}
}
</style>



// WEBPACK FOOTER //
// Remember.vue?964d76d0